import React from 'react';
import { useForm } from '../../hooks/useForm';
import StatusSection from '../StatusSection/StatusSection';
import { Row, StyledFirstColumn, StyledSecondColumn } from '../../PlusWebsiteEditor.styles';
import FooterCustomLinks from '../FooterCustomLinks/FooterCustomLinks';
import SeoSection from '../SeoSection/SeoSection';
import LogoSection from '../LogoSection/LogoSection';
import FaviconSection from '../IconSection/IconSection';
import BrandingSection from '../BrandingSection/BrandingSection';
import DomainSection from '../DomainSection/DomainSection';
import PrivatePrescriptionJourney from '../PrivatePrescriptionJourney/PrivatePrescriptionJourney';
import PatientCommunicationChannel from '../PatientCommunicationChannel/PatientCommunicationChannel';

type Props = {
  form: ReturnType<typeof useForm>;
};

const PrescriberLayout = ({ form }: Props) => {
  const {
    values,
    handleChange,
    setFieldValue,
    getError,
    handleBlur,
    faviconHandlers,
    footerCustomLinksHandlers,
    seoHandlers,
    brandingHandlers,
  } = form;

  return (
    <>
      <StatusSection enabled={values.enabled} onSwitch={setFieldValue} deployed={values.deployed} />
      <Row>
        <StyledFirstColumn>
          <FooterCustomLinks {...footerCustomLinksHandlers} links={values.footer_custom_links} />
          <SeoSection {...seoHandlers} {...values.meta} />
        </StyledFirstColumn>
        <StyledSecondColumn>
          <LogoSection
            primaryColor={values.branding?.colors?.primary}
            getError={getError}
            onChange={setFieldValue}
            logo={values.logo}
            logo_url={values.logo_url}
            logo_white={values.logo_white}
            logo_url_white={values.logo_url_white}
          />
          <FaviconSection {...faviconHandlers} favicon={values.favicon} />
          <BrandingSection {...brandingHandlers} {...values.branding} />
          <DomainSection
            onBlur={handleBlur}
            getError={getError}
            onFieldChange={setFieldValue}
            onChange={handleChange}
            domain={values.domain}
            homepage_url={values.homepage_url}
          />
          <PrivatePrescriptionJourney
            onChange={setFieldValue}
            getError={() => getError('private_prescriptions_journey')}
            privatePrescriptionsJourney={values.private_prescriptions_journey}
          />
          <PatientCommunicationChannel
            onChange={setFieldValue}
            getError={() => getError('communication_channel')}
            communicationChannel={values.communication_channel}
          />
        </StyledSecondColumn>
      </Row>
    </>
  );
};

export default PrescriberLayout;
